import React, { FC, useState } from "react";
import { UsersListItemDto } from "@green0meter/api-client";

import UsersManagement from "./UsersManagement";
import UsersManagementSkeleton from "./UsersManagement.skeleton";

import { useGetUsers } from "@api";
import { useUserStore } from "@store/user";



const UsersManagementContainer: FC = () => {
  const { user } = useUserStore();
  const [companyNameFilter, setCompanyNameFilter] = useState("");
  const [companyIdFilter, setCompanyIdFilter] = useState("");
  const [createUserDialogOpen, setCreateUserDialogOpen] = useState(false);
  const [editUser, setEditUser] = useState<UsersListItemDto>();
  const [blockUserConfirmation, setBlockUserConfirmation] =
    useState<UsersListItemDto>();
  const { usersEnabled, isPendingGetUsers } = useGetUsers(user);

  const handleCopanyNameFilter = (query: string): void => {
    setCompanyNameFilter(query);
  };

  const handleCopanyIdFilter = (query: string): void => {
    setCompanyIdFilter(query);
  };

  const handleCreateUser = (): void => {
    setEditUser(undefined);
    setCreateUserDialogOpen(true);
  };

  const handleEditUser = (user: UsersListItemDto): void => {
    setEditUser(user);
  };

  const handleCloseUserEditor = (): void => {
    setEditUser(undefined);
    setCreateUserDialogOpen(false);
  };

  const handleBlockUser = (user: UsersListItemDto): void => {
    setBlockUserConfirmation(user);
  };

  const cancelBlockUser = (): void => {
    setBlockUserConfirmation(undefined);
  };

  return (
    usersEnabled &&
    (isPendingGetUsers ? (
      <UsersManagementSkeleton />
    ) : (
      <UsersManagement
        handleCreateUser={handleCreateUser}
        companyNameFilter={companyNameFilter}
        handleCopanyNameFilter={handleCopanyNameFilter}
        companyIdFilter={companyIdFilter}
        handleCopanyIdFilter={handleCopanyIdFilter}
        editUser={editUser}
        handleEditUser={handleEditUser}
        userEditorOpen={!!editUser || createUserDialogOpen}
        handleCloseUserEditor={handleCloseUserEditor}
        handleBlockUser={handleBlockUser}
        cancelBlockUser={cancelBlockUser}
        blockUserConfirmation={blockUserConfirmation}
      />
    ))
  );
};

export default UsersManagementContainer;
